import { render, staticRenderFns } from "./SeasonTable.vue?vue&type=template&id=06c2a790&scoped=true&"
import script from "./SeasonTable.vue?vue&type=script&lang=js&"
export * from "./SeasonTable.vue?vue&type=script&lang=js&"
import style0 from "./SeasonTable.vue?vue&type=style&index=0&id=06c2a790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2a790",
  null
  
)

export default component.exports